export const MOMENT_DATE_FORMAT = 'DD MMM y';
export const DATE_FORMAT = 'dd MMM yyyy';
export const DATETIME_FORMAT = 'd MMM, h:mm a z';
export const TIME_FORMAT = 'h:mm:ss a z';
export const FILTER_DATE_FORMAT = 'YYYY-MM-DD';
export const FORM_DATE_FORMAT = 'YYYY-MM-DD';
